"use strict";
/**
 * Created by SH: 02/20/2020
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReelEngineManager = void 0;
const pixi_js_1 = require("pixi.js");
const SymbolData_1 = require("./symbol/config/SymbolData");
const ResizeHelper_1 = require("../../utils/ResizeHelper");
const SpinEvent_1 = require("../../spin/event/SpinEvent");
const StageEvent_1 = require("../../stage/event/StageEvent");
const ServerEvent_1 = require("../../server/event/ServerEvent");
const ScreenEvent_1 = require("../../screen/event/ScreenEvent");
const EventHandler_1 = require("../../event/EventHandler");
const ReelEngineController_1 = require("./ReelEngineController");
const MathHelper_1 = require("../../utils/MathHelper");
const GameConfig_1 = require("../../gameconfig/GameConfig");
class ReelEngineManager {
    static get dim() { return ResizeHelper_1.ResizeHelper.calcDim(this.reelDim); }
    ;
    get dim() { return ReelEngineManager.dim; }
    ;
    static get isPlaying() { return this._playing; }
    static set isPlaying(value) { this._playing = value; }
    static get isSpinning() {
        for (var i = 0; i < this.AllReels.length; i++) {
            if (this.AllReels[i].isActive && !this.AllReels[i].state.equal(ReelEngineController_1.ReelState.STEP))
                return false;
        }
        return true;
    }
    ;
    static get AllReels() { return this._reels; }
    ;
    get AllReels() { return this.AllReels; }
    ;
    static getReel(ID) {
        for (var searchID = 0; searchID < this._reels.length; searchID++)
            if (this._reels[searchID].reelID == ID)
                return this._reels[searchID];
        debugger;
        throw console.error("Can't find the reel with ID: " + ID);
    }
    ;
    constructor(config) {
        this.addEventListeners();
        this.createEngineControllers(config);
    }
    ;
    createEngineControllers(config) {
        for (var id = 0; id < config.REEL_AMOUNT; id++) {
            this.AllReels.push(new ReelEngineController_1.ReelEngineController({
                reelID: id,
                engine_config: config
            }));
        }
    }
    addEventListeners() {
        // ScreenEvent-Event *
        EventHandler_1.EventHandler.addEventListener(this, ScreenEvent_1.ScreenEvent.GAME_READY, () => this.initialize());
        // Server-Events *
        EventHandler_1.EventHandler.addEventListener(this, ServerEvent_1.ServerEvent.INIT_DATA_PARSED, (event) => this.parseData(event.params[0]));
        EventHandler_1.EventHandler.addEventListener(this, ServerEvent_1.ServerEvent.GAME_DATA_PARSED, (event) => this.parseData(event.params[0]));
        // PresentationGameEvent-Event *
        EventHandler_1.EventHandler.addFirstEventListener(this, SpinEvent_1.SpinEvent.STOP, (event) => this.setQuickStop(event.params[0]));
        // API-Event *
        EventHandler_1.EventHandler.addEventListener(this, StageEvent_1.StageEvent.STAGE_RESIZED, (event) => this.updateAllReelPos(event.params[0]));
    }
    ;
    setQuickStop(val) {
        if (!!val)
            this.AllReels.forEach((reel) => reel.isQuickStop = val);
    }
    parseData(data) { this.AllReels.forEach(reel => { reel.dataParsed(data); }); }
    initialize() {
        SymbolData_1.SymbolData.InitSymbolData();
        this.AllReels.forEach(reel => {
            reel.initReel();
            reel.onStageResized(this.dim);
        });
    }
    updateAllReelPos(resizeData) {
        this.AllReels.forEach(reel => { reel.onStageResized(this.dim); });
    }
    static onBeforeSpinStart() {
        this.isPlaying = false;
        this.AllReels.forEach((reel) => reel.isQuickStop = false);
    }
    ;
    static get isQuickStop() {
        for (let r = 0; r < this.AllReels.length; r++) {
            if (this.AllReels[r].isQuickStop)
                return true;
        }
        return false;
    }
    static get ReelAreaWidth() {
        const ReelAreaX = this.AllReels[0].engineConfig.DIM.WIDTH * this.AllReels.length;
        const ReelAreaPaddingX = this.AllReels[0].engineConfig.DIM.PADDING_X * (this.AllReels.length - 1);
        return ReelAreaX + ReelAreaPaddingX;
    }
    static get ReelAreaHeight() {
        return this.AllReels[0].engineConfig.DIM.HEIGHT + this.AllReels[0].engineConfig.DIM.PADDING_Y;
    }
    static RAll(func) {
        for (let reel = 0; reel < this.AllReels.length; reel++) {
            if (this.AllReels[reel].visible)
                func(this.AllReels[reel].reelID);
        }
    }
    ;
    static RSAll(func) {
        for (let reel = 0; reel < this.AllReels.length; reel++) {
            for (let row = 0; row < this.AllReels[reel].AllSymbols.length; row++) {
                func(this.AllReels[reel].reelID, this.AllReels[reel].AllSymbols[row].posID);
            }
        }
    }
    ;
    static RSWindow(func) {
        this.RAll((reelID) => {
            for (let symID = 0; symID < this.getReel(reelID).windowAmount; symID++)
                func(this.AllReels[reelID].reelID, symID);
        });
    }
    ;
    static getNextReelID(reelID) {
        for (let r = reelID + 1; reelID < this.AllReels.length; reelID++)
            if (r < this.AllReels.length && this.AllReels[r].visible)
                return r;
        return -1;
    }
    ;
    static findFirstReelWithState(state) {
        for (var i = 0; i < this.AllReels.length; i++) {
            if (this.AllReels[i].isActive && (this.AllReels[i].state.equal(state)))
                return this.AllReels[i].reelID;
        }
        return -1;
    }
    ;
    // public static reels(state:string):number {
    //     for (var i = 0; i < this.AllReels.length; i++) {
    //         if(this.AllReels[i].isActive && (this.AllReels[i].state.equal(state))) return this.AllReels[i].reelID;
    //     }
    //     return -1;
    // };
    static findLastReelWithState(state) {
        for (var i = this.AllReels.length - 1; i >= 0; i++) {
            if (this.AllReels[i].isActive && this.AllReels[i].state.equal(state))
                return this.AllReels[i].reelID;
        }
        return -1;
    }
    ;
    static getStoppingReel() {
        for (var i = 0; i < this.AllReels.length; i++) {
            if (this.AllReels[i].isActive && (this.AllReels[i].state.isStopping || this.AllReels[i].state.willStop))
                return this.AllReels[i].reelID;
        }
        return -1;
    }
    static getReelPos(reelIndex) {
        if (GameConfig_1.GameConfig.instance.REEL_ENGINE_POSITIONS)
            return MathHelper_1.MathHelper.pointAdd(GameConfig_1.GameConfig.instance.REEL_ENGINE_POSITIONS[reelIndex], this.dim.position);
        return new pixi_js_1.Point(0);
    }
}
ReelEngineManager.reelDim = {
    dimOrientation: {
        landscape: {
            scale: new pixi_js_1.Point(1),
            position: new pixi_js_1.Point(0),
            layout: {
                left: new pixi_js_1.Point(0),
                right: new pixi_js_1.Point(0)
            }
        },
        portrait: {
            scale: new pixi_js_1.Point(1),
            position: new pixi_js_1.Point(0)
        }
    },
    WIDTH: 0,
    HEIGHT: 0,
};
ReelEngineManager._reels = [];
exports.ReelEngineManager = ReelEngineManager;
//# sourceMappingURL=ReelEngineManager.js.map